module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido3.33394c0d.svg";